import { required, minLength } from 'vuelidate/lib/validators';

export const validSurveyQuestions = (qs = {}) => {
  if (!qs || !Array.isArray(qs) || qs.length === 0) {
    return false;
  }

  const isValid = qs.every(q => {
    if (!q || typeof q !== 'object') {
      return false;
    }
    if (!q.title || q.title.trim() === '') {
      return false;
    }
    if (!q.type || q.type.trim() === '') {
      return false;
    }
    if (
      ![
        'dropdown_list',
        'combo_selection',
        'number-rating',
        'smiley_rating',
        'star_rating',
        'checkbox',
        'free_text',
        'number_input',
        'phone',
        'email',
        'multiple_choice_markup',
        'single_choice_markup',
      ].includes(q.type)
    ) {
      return false;
    }
    if (q.mandatory !== undefined && typeof q.mandatory !== 'boolean') {
      return false;
    }
    if (q.enabled !== undefined && typeof q.enabled !== 'boolean') {
      return false;
    }
    if (q.options && !Array.isArray(q.options)) {
      return false;
    }
    if (
      q.type === 'dropdown_list' ||
      q.type === 'combo_selection' ||
      q.type === 'multiple_choice_markup' ||
      q.type === 'single_choice_markup'
    ) {
      if (q.options.length > 0) {
        if (!q.options.every(opt => opt !== '')) {
          return false;
        }
      } else {
        return false;
      }
    }
    return true;
  });

  if (!isValid) {
    return false;
  }

  const mandatoryCount = qs.filter(q => q.mandatory === true).length;
  if (mandatoryCount < 1) {
    return false;
  }

  const eneabledCount = qs.filter(q => q.enabled === true).length;
  if (eneabledCount < 1) {
    return false;
  }

  const mandatoryEnabledCount = qs.filter(
    q => q.mandatory === true && q.enabled === true
  ).length;
  if (mandatoryEnabledCount < 1) {
    return false;
  }

  return true;
};

export default {
  title: {
    required,
    minLength: minLength(2),
  },
  description: {},
  welcomeMessage: {},
  questions: {
    required,
    minLength: minLength(1),
    validSurveyQuestions,
  },
};
